/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Actions from '../../../actions/actions';

import Icon from '../../icons/Icon';

import { DefaultServices } from '../../../constants/DefaultServices';

import Counter from '../../elements/Counter';

/* eslint max-len: 0 */
export class StatsWidget extends Component {
    constructor(props) {
        super(props);

        this.oldStats = {
            total: 0,
            reviewsCount: 0,
        };
    }

    componentWillMount() {
        this.props.actions.updateStats(this.props.person.getDataAsSearchParams());
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.person.getDataAsSearchParams() !== nextProps.person.getDataAsSearchParams()) {
            this.oldStats.total = this.props.total;
            this.oldStats.reviewsCount = this.props.reviewsCount;

            this.props.actions.updateStats(nextProps.person.getDataAsSearchParams());
        }
    }

    renderVerticalMode() {
        const serviceDescription = DefaultServices.get(this.props.person.get('needKey')) ?
            DefaultServices.get(this.props.person.get('needKey')).get('description') : 'investments';

        return (
            <div>
                <div className="app__stats-widget__item margin">
                    <div className="vertical-label">
                        VouchedFor Advisers
                    </div>
                    <div className="vertical-sub-label push-down-10">
                        { serviceDescription }
                    </div>
                    <div className="app__stats-widget__number spaced">
                        <Counter from={ this.oldStats.total }
                                 to={ this.props.total } delay={ 30 } speed={ 1200 }/>
                    </div>
                </div>

                <div className="app__stats-widget__item margin">
                    <div className="vertical-label">
                        Average rating
                    </div>
                    <div className="vertical-sub-label push-down-10">
                        from genuine client reviews
                    </div>
                    <div className="app__stats-widget__number padding-right-45">
                        { this.props.averageScore }
                        <div className="app__stats-widget__icon">
                            <Icon icon="star" style={ { fill: 'gold' } } size="26px"/>
                        </div>
                    </div>
                    <div className="vertical-sub-label push-down-10">
                        out of 5 stars
                    </div>
                </div>

                <div className="app__stats-widget__item">
                    <div className="vertical-label">
                        Clients helped
                    </div>
                    <div className="vertical-sub-label push-down-10">
                        who have received advice from these IFAs
                    </div>
                    <div className="vertical-orientation">
                        <div className="app__stats-widget__number spaced full">
                            <Counter from={ this.oldStats.averageScore }
                                     to={ this.props.reviewsCount } delay={ 30 } speed={ 1200 }/>
                        </div>
                    </div>
                </div>

                <div className="vertical-label__list--mobile">
                    <div className="vertical-label--mobile">
                        Advisers
                    </div>
                    <div className="vertical-label--mobile">
                        out of 5
                    </div>
                    <div className="vertical-label--mobile">
                        reviews
                    </div>
                </div>

            </div>
        );
    }

    renderHorizontalMode() {
        return (
            <div className="app__stats-widget__container">
                <div className="mobile-line">VouchedFor has</div>
                <div className="app__stats-widget__number spaced">
                    <Counter from={ this.oldStats.total }
                             to={ this.props.total } delay={ 30 } speed={ 1200 }/>
                </div>
                <div className="mobile-line">
                    advisers who can help with this, with an average review rating of
                </div>
                <div className="app__stats-widget__number padding-right-45">
                    { this.props.averageScore }
                    <div className="app__stats-widget__icon">
                        <Icon icon="star" style={ { fill: 'gold' } } size="26px"/>
                    </div>
                </div>

                <div className="line">
                    <div className="mobile-line">They've helped</div>
                    <div className="app__stats-widget__number spaced">
                        <Counter from={ this.oldStats.averageScore }
                                 to={ this.props.reviewsCount } delay={ 30 } speed={ 1200 }/>
                    </div>
                    <div className="mobile-line">others like you</div>
                </div>
            </div>
        );
    }

    render() {
        const container = this.props.isVertical ? this.renderVerticalMode() : this.renderHorizontalMode();
        const verticalMode = this.props.isVertical ? 'vertical-mode' : '';

        return (
            <div className={ `app__stats-widget__container ${verticalMode}` }>
                { container }
            </div>
        );
    }
}

StatsWidget.propTypes = {
    person: React.PropTypes.object,
    actions: React.PropTypes.object,

    total: React.PropTypes.number,
    reviewsCount: React.PropTypes.number,
    averageScore: React.PropTypes.number,

    isVertical: React.PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        person: state.reducer.get('person'),

        total: state.stats.get('total'),
        reviewsCount: state.stats.get('reviewsCount'),
        averageScore: state.stats.get('averageScore'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatsWidget);



// WEBPACK FOOTER //
// ./src/components/steps/matching/StatsWidget.jsx